const config = {
  defaultPath: '/',
  i18n: 'en',
}

export const appName = 'Q\u00A0Care\u00A0Plus'

/** Time in seconds for inactivity check */
export const inactivityTime = 300

export default config
